import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

import { useNavigate } from 'react-router-dom'; // React Router for navigation
import axios from 'axios';
import { io } from "socket.io-client";
const ProductContext = createContext();

function AppContext({ children }) {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const authToken = localStorage.getItem('AuthToken');

  if (authToken) {
    try {
      const base64Url = authToken.split('.')[1];
      if (base64Url) {
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          window.atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        );
        const decoded = JSON.parse(jsonPayload);
        if (decoded && decoded.language) {
          const tokenLang = decoded.language;
          const currentLang = localStorage.getItem("selectedLanguage");
          // Update selectedLanguage if it is unset or doesn't match the token's language
          if (currentLang !== tokenLang) {
            localStorage.setItem("selectedLanguage", tokenLang);
          }
        }
      }
    } catch (e) {
      console.error("Error parsing language from token in AppContext:", e);
    }
  }

  const BASE_URL = process.env.REACT_APP_BASE_URL;


  const [error, setError] = useState(null);
  const navigate = useNavigate(); // React Router for navigation
  const [ExamTypedata, setExamTypedata] = useState();
  const [skippedCount, setSkippedCount] = useState(0);
  const [correctCount, setCorrectCount] = useState(0);
  const [incorrectCount, setIncorrectCount] = useState(0);
  const [Universitydata, setUniversityData] = useState([]);
  const [Leveldata, setLevelData] = useState([]);
  const [hasSubscribed, setHasSubscribed] = useState(false);
  const [couponVerified, setCouponVerified] = useState(false);
  const [examTypes, setExamTypes] = useState([]);
  // const [levelData, setLevelData] = useState([]);
  const [quizTypes, setQuizTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [Usercount, setUserCount] = useState(null);
  const [username, setUsername] = useState(null);
  const [totalHours, setTotalHours] = useState(0); // Dynamic total hours
  const [totalMinutes, setTotalMinutes] = useState(0);
  const [skit, setSkits] = useState([]);
  const [Translate, setTranslate] = useState(null);
  const [notificationsByType, setNotificationsByType] = useState({
    group: [],
    individual: [],
  });
  // const [isLoading, setIsLoading] = useState(true);
  console.log(authToken, 'authToken Check Auth 22')
  const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
  console.log(SelectLanguageLocal, "SelectLanguageLocal");
  const [VisitedCountData, setVisitedCountData] = useState(null);
  console.log("usernameAuth:", username);
  const [ExamLevelId, setExamLevelId] = useState(null);
  const [marker, setMarker] = useState([])
  const [selectedExamId, setSelectedExamId] = useState(null);
  const socketRef = React.useRef(null);
  const socketUrl =
    process.env.REACT_APP_SOCKET_URL ||
    process.env.REACT_APP_BASE_URL ||
    "http://localhost:3000";
  const notificationApiBaseUrl =
    process.env.REACT_APP_NOTIFICATION_API_BASE_URL ||
    process.env.REACT_APP_BASE_URL ||
    "http://localhost:3000";
  useEffect(() => {
    const storedToken = localStorage.getItem('AuthToken');
    if (storedToken) {
      console.log(storedToken); // Set in context
    }
  }, []);


  const resetQuizData = () => {
    setSkippedCount(0);
    setCorrectCount(0);
    setIncorrectCount(0);
  };




  useEffect(() => {
    const fetchDataExamType = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/exam-types`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        const levels = response?.data?.message?.examTypes?.map(exam => ({
          label: exam?.exam_type,
          value: exam?.exam_type,
        }));
        setLevelData(levels);
        setExamTypedata(response?.data?.message);
        setExamTypes(response?.data?.message?.examTypes);

      } catch (err) {
        console.error('API error:', err);
        setError(err);

        if (err.response && err.response.status === 401) {
          console.log('navigate to login due to 401');
          navigate('Login');
        }
      }
    };
    fetchDataExamType();
  }, []);
  useEffect(() => {
    const authToken = localStorage.getItem('AuthToken');

    axios
      .get(`${BASE_URL}/api/college`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then(response => {
        const universities = response.data.message.showCollege.map(college => ({
          label: college.college_name,
          value: college.college_name,
        }));
        setUniversityData(universities);
      })
      .catch(error => {
        console.error('Error fetching universities:', error);
      });



    axios
      .get(`${BASE_URL}/api/user-subscription`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then(response => {
        if (response.data && response.data.success) {
          const activePlans = response.data.message.plan.filter(
            plan => plan.status === 'active',
          );
          setHasSubscribed(activePlans.length > 0);
        } else {
          console.log('No valid data or success flag:', response.data);
        }
      })
      .catch(error => {
        console.error('Error fetching exam types:', error);
      });

    axios
      .get(`${BASE_URL}/api/quizTypes`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then(response => {
        if (response.data.success) {
          setQuizTypes(response.data.message.quizTypes);
          response.data.message.quizTypes.forEach((quizType) => {
            // console.log(quizType.quiz_type_id, 'quizType Id New');
          });
        }
      })
      .catch(error => {
        console.error('Error fetching exam types:', error);
      });


    axios
      .get(`${BASE_URL}/api/users/all-users-count`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then(response => {
        if (response.ok) {
          const data = response.json();
          setUserCount(data);
        } else {
          console.error('Failed to fetch loan data');
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          console.log('navigate to login due to 401');
          navigate('Login'); // Navigate to login screen
        }
        console.error('Error fetching loan data:', error);
      });

  }, []);
  const [lastCallTime, setLastCallTime] = useState(null);

  const GetHours = async () => {
    const now = Date.now();

    // Check if the function was called within the last minute (60000 ms)
    if (lastCallTime && now - lastCallTime < 60000) {
      console.log("API call skipped to limit frequency.");
      return;
    }

    setLastCallTime(now); // Update the last call time

    try {
      const response = await fetch(`${BASE_URL}/api/userQuizTime`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          console.log("Navigate to login due to 401");
          navigate("/login");
          return;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("API Response Data:", data);

      const hours = data.message.result.totalHours;
      const minutes = data.message.result.minutes;

      console.log("Fetched hours and minutes:", hours, minutes);
      setTotalHours(hours);
      setTotalMinutes(minutes);
    } catch (error) {
      console.error("Error fetching total hours:", error);
    }
  };

  useEffect(() => {
    GetHours();
  }, [GetHours]);
  const [DaysLeft, setDaysLeft] = useState(null);
  useEffect(() => {
    const fetchDaysLeftData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/user-subscription/day-left`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response?.data?.success) {
          setDaysLeft(response?.data); // Set fetched translation data
        } else {
          console.error('Failed fetchLanguageData to fetch language data');
        }
      } catch (error) {
        console.error('Error fetching language fetchLanguageData data :', error);

      }
    };

    fetchDaysLeftData();
  }, []);
  useEffect(() => {
    const fetchSkit = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/skit-category`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        const data = await response.json(); // Parse JSON response
        if (data.success) {
          setSkits(data.message.skitCategories || []); // Ensure fallback for empty data
        } else {
          console.error("Failed to fetch skit categories:", data.message);
        }
      } catch (err) {
        if (err.response && err.response.status === 401) {
          console.error("Unauthorized. Redirecting to login...");
          navigate("/");
        } else {
          console.error("Error fetching skit categories:", err);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchSkit();
  }, []);
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const authToken = localStorage.getItem('AuthToken');
        console.log(authToken, 'authToken Check Auth')
        const response = await fetch(`https://api.japaking.online/api/users`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const data = await response.json();
          setUsername(data);
          setExamLevelId(data);
        } else {
          console.error('Failed to fetch profile data');
        }
      } catch (error) {
        console.error('Error fetching profile data:', error);
      }
    };

    fetchProfileData();
  }, [authToken]);

  console.log(username, "username Auth")
  useEffect(() => {
    const fetchTranslationData = async () => {
      try {
        // const authToken = localStorage.getItem("AuthToken");
        const response = await fetch(`${BASE_URL}/api/translation/${SelectLanguageLocal}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setTranslate(data); // Update fetched translations
        } else {
          console.error("Failed to fetch translation data");
        }
      } catch (error) {
        console.error("Error fetching translation data:", error);
      }
    };

    fetchTranslationData();
  }, []);

  const getCurrentUserId = useCallback(() => {
    const profileUserId = username?.message?.userDetails?.user_id;
    let storedUserId = "";
    try {
      const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
      storedUserId = storedUser?.user_id || "";
    } catch {
      storedUserId = "";
    }
    return profileUserId || storedUserId || "";
  }, [username]);

  const fetchNotificationsByType = useCallback(async (chatType) => {
    try {
      const userId = getCurrentUserId();
      if (!userId) return;

      const response = await axios.get(
        `${notificationApiBaseUrl}/api/notifications?receiverId=${userId}&chatType=${chatType}`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );

      if (response.data?.success) {
        const filteredNotifications = (response.data.message.notifications || []).filter(
          (notification) => {
            const currentUserId = Number(userId);
            const senderId = Number(notification?.sender_user?.user_id || notification?.user_id || 0);
            return currentUserId && senderId !== currentUserId;
          }
        );

        setNotificationsByType((prev) => ({
          ...prev,
          [chatType]: filteredNotifications,
        }));
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  }, [authToken, getCurrentUserId, notificationApiBaseUrl]);

  useEffect(() => {
    fetchNotificationsByType("group");
    fetchNotificationsByType("individual");
  }, [fetchNotificationsByType]);

  useEffect(() => {
    const userId = getCurrentUserId();
    if (!userId) return;

    const socket = io(socketUrl, {
      transports: ["websocket"],
      withCredentials: true,
    });

    socketRef.current = socket;

    socket.on("connect", () => {
      socket.emit("join", { user_id: userId });
    });

    socket.on("notification:new", (notification) => {
      const currentUserId = Number(userId);
      const senderId = Number(notification?.sender_user?.user_id || notification?.user_id || 0);
      if (currentUserId && senderId === currentUserId) return;
      const type = notification?.chat_type === "group" ? "group" : "individual";
      setNotificationsByType((prev) => ({
        ...prev,
        [type]: [notification, ...(prev[type] || [])],
      }));
    });

    socket.on("connect_error", (error) => {
      console.error("Global notification socket connect_error:", error);
    });

    return () => {
      socket.disconnect();
    };
  }, [getCurrentUserId, socketUrl]);

  return (
    <ProductContext.Provider value={{
      ExamTypedata,
      Universitydata,
      Leveldata,
      hasSubscribed,
      couponVerified,
      skippedCount,
      setSkippedCount,
      correctCount,
      setCorrectCount,
      incorrectCount,
      setIncorrectCount,
      resetQuizData,
      quizTypes,
      isLoading,
      Usercount,
      examTypes,
      username,
      totalHours,
      totalMinutes,
      skit,
      Translate,
      notificationsByType,
      setNotificationsByType,
      refreshNotificationsByType: fetchNotificationsByType,
      VisitedCountData, setVisitedCountData,
      marker, setMarker,
      selectedExamId, setSelectedExamId,
      DaysLeft,
      ExamLevelId,
    }}>
      {children}
    </ProductContext.Provider>
  );
}

export { ProductContext, AppContext };
